// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"306":"learner-dashboard-main","569":"instructor-dashboard-main"}[chunkId] || chunkId) + "." + {"306":"55ed2c3d739fbf20ae12","569":"3a5da8a18686cc103bc5","710":"262f4547054c669e07f2"}[chunkId] + ".js";
};